import * as React from 'react';

export type KeyboardCombinationType = {
  ctrlKey: boolean;
  metaKey: boolean;
  key: string;
};

export enum KeyboardCombinationsPlatforms {
  mac = 'mac',
  windows = 'windows',
}

type KeySubscriber = {
  combinations: KeyboardCombinationType[];
  handler: VoidFunction;
};

const matchCombination = (
  e: KeyboardEvent,
  combination: KeyboardCombinationType
) =>
  e.ctrlKey === Boolean(combination.ctrlKey) &&
  e.metaKey === Boolean(combination.metaKey) &&
  e.key === combination.key;

/** Хук-подписки на клики с клавиатуры*/
export const useKeydownSubscription = (subscribers: KeySubscriber[]) => {
  React.useEffect(() => {
    const eventHandler = (e: KeyboardEvent) => {
      subscribers.forEach((subscriber) => {
        subscriber.combinations.some((combination) => {
          if (matchCombination(e, combination)) {
            subscriber.handler();

            return true;
          }
        });
      });
    };

    document.addEventListener('keydown', eventHandler);

    return () => {
      document.removeEventListener('keydown', eventHandler);
    };
  }, [subscribers]);
};
